import api from "./api";

import axios from "axios";

export interface RegisterInterface {
    pre_reg_first_name:	string
    pre_reg_last_name: string
    pre_reg_username: string
    pre_reg_email: string
    pre_reg_password: string
}

export const registerUser = async (form: RegisterInterface): Promise<number> =>{
    try{
        const response = await api.post<number>('/api/pre_register', form)
        return response.status
    }catch (error: unknown) {
        if (axios.isAxiosError(error)) {
            if(error.status) {
                return error.status
            }
        }
        return 400
    }
}

export interface CodigoResgiser {
    email: string
    codigo: number
}

export const postCodeRegister = async (body: CodigoResgiser): Promise<number> =>{
    try{
        const response = await api.post<number>('/api/register', body)
        return response.status
    }catch (error: unknown) {
        if (axios.isAxiosError(error)) {
            if(error.status) {
                return error.status
            }
        }
        return 400
    }
}

export interface ForgotBody{
    email: string
}

export const postForgot = async (body: ForgotBody): Promise<number> =>{
    try{
        const response = await api.post<number>('/api/forgot', body)
        return response.status
    }catch (error: unknown) {
        if (axios.isAxiosError(error)) {
            if(error.status) {
                return error.status
            }
        }
        return 400
    }
}

export interface ResetBody {
    email: string
    codigo: number
    password: string
}


export const postReset = async (body: ResetBody): Promise<number> =>{
    try{
        const response = await api.post<number>('/api/reset_password', body)

        return response.status
    }catch (error: unknown) {
        if (axios.isAxiosError(error)) {
            if (error.status) {
                return error.status
            }
        }
        return 400
    }
}
